import Hero from "../components/Hero";
import ClientJourney from "../components/ClientJourney";
import Benefits from "../components/Benefits";
import PopularMoves from "../components/PopularMoves";
import CtaBanner from "../components/CtaBanner";

export default function HomePage() {
    return (
        <div data-testid="home-page">
            <Hero />
            <ClientJourney />
            <PopularMoves />
            <Benefits />
            <CtaBanner />
        </div>
    );
}
